import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

export const RT_QUOTE_US = 'RTQuote-Prequote-US-Q3-2023';

export const isRTQuoteVariant = (): boolean => getAbTestV2(RT_QUOTE_US)?.variant === 'variant';

export const trackRTQuoteABTest = (): void => trackAbTestV2Variant(RT_QUOTE_US);

export const isUS = (country?: string | null): boolean => country === 'US';
